import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'searchMember',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/SearchMemberContainer',
      './modules/searchMember'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const SearchMember = require('./containers/SearchMemberContainer').default
      const actions = require('./modules/searchMember')
      const reducer = require('./modules/searchMember').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'searchMember', reducer: reducer })

      store.dispatch(actions.clearResults())

      /*  Return getComponent   */
      cb(null, SearchMember)

    /* Webpack named bundle   */
    }, 'searchMember')
  }
})



// WEBPACK FOOTER //
// ./src/routes/SearchMember/index.js